import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withStyles} from '@mui/styles';
import {isEmpty} from '@grapecity/wijmo';
import {Field, reduxForm, getFormValues, getFormSyncWarnings} from 'redux-form';
import SaveIcon from '@mui/icons-material/Save';
import {FormControl, FormGroup} from '@mui/material';
import {HttpStatusCode} from 'axios';
import {getSessionObject} from '../../../../common/Session.js';
import {GMN, CATEGORY_TYPE, CORP_CD, OPERATION_PERMISSION_TYPE, USER_TYPE_CODE} from '../../../../common/commonConst.js';
import {getKbnList, sysErr} from '../../../../common/commonGmn.js';
import {commonOperations} from '../../../../reducks/common/index.js';
import PaperPart from '../../../atoms/PaperPart.js';
import MainContainer from '../../../organisms/MainContainer.js';
import withRouter from '../../../organisms/withRouter.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import {formatDate, searchMap} from '../../../../common/common.js';
import {renderTextField, renderCheckbox, renderSelect} from '../../../atoms/CustomPart.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
import {postRequest} from '../../../../common/backend.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import {requiredCheck, lengthCheck, dateCheck, dateFromToCheck, mailCheck} from '../../../../common/inputCheck.js';
import ResetPassword from '../../Login/resetPassword.js';
import {authOperations} from '../../../../reducks/auth/index.js';
const styles = (theme) => ({

});

/**
 * ユーザ詳細
 * 画面ID:SCZ1004
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    // パラメータ取得
    const storage = getSessionObject(GMN.USER_MASTER_INFO.id);
    let list = [].concat(
          storage?.transitionList != null ? storage.transitionList : []);
    list.push({gmnName: GMN.USER_MASTER_INFO.name, href: ''});
    this.corpList=[];
    this.prefList=[];
    this.surveyAgencyOfficeList=[];
    this.userTypeList=[];
    this.dig4ZgsyoList=[];
    let userMode;
    let userVisableFlg;
    let outUserVisableFlg;
    this.isVisible = false;
    if (storage['userId'] === '') {
      // 新規社外
      userMode = 1;
      userVisableFlg = false;
      outUserVisableFlg = true;
    } else if (storage['company'] === CORP_CD.CBID_USER) {
      // 更新社内
      userMode = 0;
      userVisableFlg = true;
      outUserVisableFlg = false;
    } else {
      // 更新社外
      userMode = 0;
      userVisableFlg = false;
      outUserVisableFlg = true;
    }
    this.state = {
      transitionList: list,
      isChanged: false,
      userMode: userMode,
      userVisableFlg: userVisableFlg,
      outUserVisableFlg: outUserVisableFlg,
      userId: storage?.userId,
      surveyAgencyOfficeCodes: [],
      userTypeSelectList: [],
      toDoFuKen: {},
      isButtonDisabled: true,
      modalOpen: false,
      userMasterData: {},
    };
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.getInitializeData();
      this.props.doSetReferenceMode(false);
      return;
    } catch (error) {
      sysErr(this.props);
    }
  }


  /**
   * 終了処理
   */
  async componentWillUnmount() {
    this.props.doSetInitValues(null);
  }

  /**
   * 初期データ検索
   */
  getInitializeData = async () => {
    const {menuItems, userInfo} = this.props;
    if (this.state.userMode==1) {
      this.isVisible=true;
      let initItems = {};
      let date = new Date();
      let year = date.getFullYear();
      let month = (date.getMonth() + 1).toString().padStart(2, '0');
      let day = date.getDate().toString().padStart(2, '0');
      initItems['yukoStartYmd'] =`${year}-${month}-${day}`;
      initItems['yukoEndYmd'] = '9999-12-31';
      initItems['isValid'] = 'true';
      this.props.doSetInitValues(initItems);
      let surveyAgencyOfficeSelectList=getKbnList(this.surveyAgencyOfficeList);
      this.setState({surveyAgencyOfficeCodes: surveyAgencyOfficeSelectList});
      let userTypeCorp=[];
      for (const userType of this.userTypeList) {
        if (userType.valueString1!==CORP_CD.CBID_USER) {
          userTypeCorp.push(userType);
        }
      }
      let userTypeSelectList=getKbnList(userTypeCorp);
      this.setState({userTypeSelectList: userTypeSelectList});
    } else {
      const storage = getSessionObject(GMN.USER_MASTER_INFO.id);
      this.setState({toDoFuKen: storage['prefCode']});
      this.searchUserData(this.state.userId);
      let isVisible = menuItems.some(
          (item) => item.gamenId === GMN.USER_MASTER_INFO.gmnId &&
                        item.operationPermissionType ===
                            OPERATION_PERMISSION_TYPE.EXECUTE);    // 実行権限
      if (isVisible) {
        // システム管理者或いは本社システム管理
        if (userInfo.userTypeCode===USER_TYPE_CODE.SYSTEM_KANRI||
          userInfo.userTypeCode===USER_TYPE_CODE.HONSYASYSTEM_KANRI) {
          this.isVisible=true;
        // 本社業務管理或いはNWC管理職或いはNWC担当者
        } else if (userInfo.userTypeCode===USER_TYPE_CODE.HONSYAGYOMU_KANRI||
          userInfo.userTypeCode===USER_TYPE_CODE.NWC_KANRI||
          userInfo.userTypeCode===USER_TYPE_CODE.NWC_TANTOU) {
          // 自ユーザのみ
          if (this.state.userId===userInfo.userId) {
            this.isVisible=true;
          }
        }
      }
    }
  };

  /**
     * 画面項目データ設定
     * @param {Object} userId
     */
  searchUserData = async (userId) => {
    try {
      let _body = {
        userId: userId,
      };
      // リクエスト出す
      const response = await postRequest('scz1004/search-user-master', _body);
      if (!response || response.status != HttpStatusCode.Ok) {
        if (response.data?.message != null) {
          this.props.doShowMessage({
            message: {
              id: response.data?.message.id,
              text: response.data?.message.text,
            },
          });
        } else {
          this.props.doShowMessage({
            message: {id: 'TKSCS00011E', values: ['ユーザ', '取得']},
          });
        }
        return;
      }
      // 画面項目データ設定
      this.setInitializeData(response);
    } catch (error) {
      sysErr(this.props);
    }
  };

  /**
   * 項目変更
   * @param {*} e
   * @param {*} v
   */
  textChange = (e, v) => {
    this.setState({isChanged: true, isButtonDisabled: false});
  };


  /**
     * 画面項目データ設定
     * @param {Object} response
     */
  setInitializeData = (response) => {
    let initItems = {};
    this.updateTime= response.data.userMaster.updateTime;
    initItems['userId'] = response.data.userMaster.userId;
    initItems['userNm'] = response.data.userMaster.userNm;
    initItems['userNmkn'] = response.data.userMaster.userNmkn;
    initItems['abbrUserNm'] = response.data.userMaster.abbrUserNm;
    if (this.state.userVisableFlg) {
      initItems['corpCd'] = response.data.userMaster.corpCd;
      let userTypeNm='';
      for (const userType of this.userTypeList) {
        if (userType.cd==response.data.userMaster.userTypeCode) {
          userTypeNm=userType.cdNameAbbr;
        }
      }
      initItems['userTypeCode'] = userTypeNm;
      let dig4ZgsyoNm='';
      for (const dig4Zgsyo of this.dig4ZgsyoList) {
        if (dig4Zgsyo.cd==response.data.userMaster.dig4ZgsyoCd) {
          dig4ZgsyoNm=dig4Zgsyo.cdNameAbbr;
        }
      }
      initItems['dig4ZgsyoCd'] = dig4ZgsyoNm;
    } else {
      initItems['corpCd'] = response.data.userMaster.corpCd;
      initItems['userTypeCode'] = response.data.userMaster.userTypeCode;
      let toDoFuKenCd='';
      for (const surveyAgencyOffice of this.surveyAgencyOfficeList) {
        if (surveyAgencyOffice.cd==
          response.data.userMaster.surveyAgencyOfficeCode) {
          toDoFuKenCd=surveyAgencyOffice.valueString4;
        }
      }
      initItems['toDoFuKen'] = toDoFuKenCd;
      initItems['surveyAgencyOfficeCode'] = response.data.userMaster.surveyAgencyOfficeCode;
      let surveyAgencyOfficeKen=[];
      for (const surveyAgency of this.surveyAgencyOfficeList) {
        if (surveyAgency.valueString4==toDoFuKenCd) {
          surveyAgencyOfficeKen.push(surveyAgency);
        }
      }
      let surveyAgencyOfficeSelectList=getKbnList(surveyAgencyOfficeKen);
      this.setState({surveyAgencyOfficeCodes: surveyAgencyOfficeSelectList});
    }
    initItems['yukoStartYmd'] = response.data.userMaster.yukoStartYmd;
    initItems['yukoEndYmd'] = response.data.userMaster.yukoEndYmd;
    initItems['mailaddress'] = response.data.userMaster.mailaddress;
    initItems['noticeTarget'] = response.data.userMaster.noticeTarget;
    initItems['isValid'] = response.data.userMaster.isValid;
    let userTypeCorp=[];
    for (const userType of this.userTypeList) {
      if (userType.valueString1==response.data.userMaster.corpCd) {
        userTypeCorp.push(userType);
      }
    }
    let userTypeSelectList=getKbnList(userTypeCorp);
    this.setState({
      userTypeSelectList: userTypeSelectList,
      userMasterData: response.data.userMaster,
    });
    this.props.doSetInitValues(initItems);
  };
  /**
   * 更新ボタンクリック時
   *
   */
  doSave = async () => {
    const {values} = this.props;
    let _warningMessages = this.inputCheck(values);
    let msg='';
    if (this.state.userMode == 1) {
      msg='登録';
    } else {
      msg='更新';
    }
    this.setState({
      warningMessages: _warningMessages,
    });
    if (_warningMessages.length > 0) {
      this.props.doShowMessage({
        message: {id: 'TKSCS00012E', values: ['入力エラーの', msg]},
      });
      return;
    }
    this.props.doShowMessage({
      message: {
        id: 'TKSCS00002C',
        values: [msg],
      },
      action: () => {
        this.updateAction();
      },
    });
  };

  /**
     * 更新処理
     */
  updateAction = async () => {
    const {values} = this.props;
    let _warningMessages = [];
    let userMasterData=values;
    try {
      let _url='';
      let msg='';
      if (this.state.userId === '') {
        _url='scz1004/insert-user-master';
        msg='登録';
      } else {
        _url='scz1004/update-user-master';
        msg='更新';
        userMasterData.updateTime=this.updateTime;
      }
      let _body = {
        userMasterData: userMasterData,
      };
      const response = await postRequest(_url, _body);
      if (response.status != HttpStatusCode.Ok) {
        if (response.data?.detailMessages != null) {
          _warningMessages = response.data?.detailMessages;
        }
        if (response.data?.message != null) {
          this.props.doShowMessage({
            message: {id: response.data?.message.id,
              text: response.data?.message.text},
          });
        }
        return;
      } else {
        this.props.doShowMessage({
          message: {id: 'TKSCS00004I', values: [msg]},
          action: () => {
            this.refresh(response);
          },
        });
      }
    } catch (error) {
      sysErr(this.props);
    } finally {
      this.setState({
        warningMessages: _warningMessages,
      });
    }
  };

  /**
   * 画面refresh
   *  @param {Object} response
   *
   */
  refresh = (response) => {
    this.setInitializeData(response);
    this.setState({isChanged: false,
      isButtonDisabled: true,
      userId: response.data.userMaster.userId, userMode: 0});
  };

  /**
   * パスワードリセットクリック時
   *
   */
  doPasswordReset = async () => {
    const {values, doShowMessage} = this.props;

    // ユーザIDを取得
    const userId = values.userId;

    const userMasterData = this.state.userMasterData;

    // 無効なユーザの場合はエラー
    if (!userMasterData.isValid) {
      doShowMessage({
        message: {
          id: 'TKSCZ00023E',
          values: [userId],
        },
      });
      return;
    }

    const sysDate = formatDate(new Date(), 'yyyy-MM-dd');
    // 有効期限切れユーザの場合はエラー
    if (userMasterData.yukoStartYmd > sysDate ||
       userMasterData.yukoEndYmd < sysDate) {
      doShowMessage({
        message: {
          id: 'TKSCZ00026E',
          values: [userId],
        },
      });
      return;
    }

    // 確認メッセージ表示
    doShowMessage({
      message: {
        id: 'TKSCS00003C',
        values: [`「${userId}」のパスワード`, '再発行'],
      },
      action: () =>{
        // パスワード再発行
        this._execResetPassword(userId);
      },
    });
  };

  /**
   * パスワードリセット実行。
   * @private
   * @param {string} userName ユーザID
   * @return {string} 実行結果
   */
  _execResetPassword = async (userName) => {
    const {
      doShowMessage,
      sendAuthenticationCode,
    } = this.props;

    const result = await sendAuthenticationCode(userName);

    switch (result) {
      // 処理成功
      case 'OK':
        doShowMessage({
          message: {
            id: 'TKSCS00004I',
            values: ['パスワードリセットのメールを送付'],
          },
        });
        break;

        // リセット回数制限エラー
      case 'LIMIT_EXCEED':
        doShowMessage({
          message: 'TKSCZ00056E',
        });
        break;

        // その他エラーはシステムエラー
      default:
        doShowMessage({
          message: 'TKSCS00001S',
          action: this.doMoveLogin(),
        });
        break;
    }
  };

  /**
   * ログイン画面へ遷移する
   */
  doMoveLogin = () => {
    this.props.navigate('/login');
  };

  /**
   * 入力チェック
   * @param {object} items 画面入力値
   * @return {array} エラーメッセージ
   */
  inputCheck = (items) => {
    let _warning = [];
    let resultList = [];

    const fromLabel='有効開始年月日';
    const toLabel ='有効終了年月日';
    if (this.state.outUserVisableFlg) {
      // 必須チェック
      resultList.push(requiredCheck('ユーザ氏名', items.userNm));
      resultList.push(requiredCheck('会社', items.corpCd));
      resultList.push(requiredCheck('調査機関事業所', items.surveyAgencyOfficeCode));
      resultList.push(requiredCheck(fromLabel, items.yukoStartYmd));
      resultList.push(requiredCheck(toLabel, items.yukoEndYmd));
      resultList.push(requiredCheck('ユーザ種別', items.userTypeCode));
      resultList.push(requiredCheck('メールアドレス', items.mailaddress));
      // 長度チェック
      if (!isEmpty(items.userNm)) {
        resultList.push(this._lengthCheck(40, 'ユーザ氏名', items.userNm));
      }
      if (!isEmpty(items.userNmkn)) {
        resultList.push(this._lengthCheck(20, 'ユーザ氏名カナ', items.userNmkn));
      }
      if (!isEmpty(items.abbrUserNm)) {
        resultList.push(this._lengthCheck(20, 'ユーザ略名', items.abbrUserNm));
      }
      if (!isEmpty(items.mailaddress)) {
        resultList.push(this._lengthCheck(255, 'メールアドレス', items.mailaddress));
      }
      // 日付妥当性チェック
      if (!isEmpty(items.yukoStartYmd)) {
        resultList.push(dateCheck(fromLabel, items.yukoStartYmd));
      }
      if (!isEmpty(items.yukoEndYmd)) {
        resultList.push(dateCheck(toLabel, items.yukoEndYmd));
      }
      // 日付整合性チェック
      if (!isEmpty(items.yukoEndYmd)&&!isEmpty(items.yukoStartYmd)) {
        resultList.push(dateFromToCheck(
            fromLabel, items.yukoStartYmd, toLabel, items.yukoEndYmd));
      }
      // メールチェック
      if (!isEmpty(items.mailaddress)) {
        resultList.push(mailCheck('メールアドレス', items.mailaddress));
      }
    } else {
      resultList.push(requiredCheck('メールアドレス', items.mailaddress));
      // メールチェック
      if (!isEmpty(items.mailaddress)) {
        resultList.push(mailCheck('メールアドレス', items.mailaddress));
      }
    }
    for (const result of resultList) {
      if (result.error) {
        _warning.push(result.message);
      }
    }

    return _warning;
  };

  /**
   * 社内ユーザの要素生成
   * @return {*}
   */
  _getuserInfo() {
    let inCorp=[];
    for (const corp of this.corpList) {
      if (corp.cd==CORP_CD.CBID_USER) {
        inCorp.push(corp);
      }
    }
    let inCorpSelectList = getKbnList(inCorp);
    let isDisabled = !this.isVisible;
    return (
      <PaperPart>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="userId" item xs={12} sm={3}>
            <Field
              id="userId"
              name="userId"
              component={renderTextField}
              className="fields"
              label="ユーザID"
              fullWidth
              type="text"
              required={false}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid key="userNm" item xs={12} sm={3}>
            <Field
              id="userNm"
              name="userNm"
              component={renderTextField}
              className="fields"
              label="ユーザ氏名"
              fullWidth
              type="text"
              onChange={this.textChange}
              required={false}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid key="userNmkn" item xs={12} sm={3}>
            <Field
              id="userNmkn"
              name="userNmkn"
              component={renderTextField}
              className="fields"
              label="ユーザ氏名カナ"
              fullWidth
              type="text"
              onChange={this.textChange}
              required={false}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid key="abbrUserNm" item xs={12} sm={3}>
            <Field
              id="abbrUserNm"
              name="abbrUserNm"
              component={renderTextField}
              className="fields"
              label="ユーザ略名"
              fullWidth
              type="text"
              onChange={this.textChange}
              required={false}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="corpCd" item xs={12} sm={3}>
            <Field
              id="corpCd"
              name="corpCd"
              component={renderSelect}
              className="fields"
              fullWidth
              label="会社"
              type="text"
              onChange={this.textChange}
              InputProps={{
                readOnly: true,
              }}
            >
              {inCorpSelectList}
            </Field>
          </Grid>
          <Grid key="dig4ZgsyoCd" item xs={12} sm={3}>
            <Field
              id="dig4ZgsyoCd"
              name="dig4ZgsyoCd"
              component={renderTextField}
              className="fields"
              fullWidth
              label="NW事業所"
              type="text"
              onChange={this.textChange}
              InputProps={{
                readOnly: true,
              }}
            >
            </Field>
          </Grid>
          <Grid key="yukoStartYmd" item xs={12} sm={3}>
            <Field
              id="yukoStartYmd"
              name="yukoStartYmd"
              component={renderTextField}
              className="fields"
              fullWidth
              label="有効開始年月日"
              type="date"
              onChange={this.textChange}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid key="yukoEndYmd" item xs={12} sm={3}>
            <Field
              id="yukoEndYmd"
              name="yukoEndYmd"
              component={renderTextField}
              className="fields"
              fullWidth
              label="有効終了年月日"
              type="date"
              onChange={this.textChange}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="userTypeCode" item xs={12} sm={3}>
            <Field
              id="userTypeCode"
              name="userTypeCode"
              component={renderTextField}
              className="fields"
              fullWidth
              label="ユーザ種別"
              type="text"
              onChange={this.textChange}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid key="mailaddress" item xs={12} sm={3}>
            <Field
              id="mailaddress"
              name="mailaddress"
              component={renderTextField}
              className="fields"
              fullWidth
              required={true}
              label="メールアドレス"
              type="text"
              onChange={this.textChange}
              InputProps={{
                readOnly: isDisabled,
              }}
            />
          </Grid>
          <Grid key="noticeTarget" item xs={12} sm={2}>
            <FormControl component="fieldset" className="formControl">
              <FormGroup row={true}>
                <Field className="checkbox"
                  id="noticeTarget"
                  name="noticeTarget"
                  component={renderCheckbox}
                  label="通知対象"
                  onChange={this.textChange}
                  validate={[]}
                  sx={{marginLeft: '20px'}}
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid key="isValid" item xs={12} sm={2}>
            <FormControl component="fieldset" className="formControl">
              <FormGroup row={true}>
                <Field className="checkbox"
                  id="isValid"
                  name="isValid"
                  component={renderCheckbox}
                  label="有効フラグ"
                  onChange={this.textChange}
                  validate={[]}
                  sx={{marginLeft: '20px'}}
                  disabled="true"
                />
              </FormGroup>
            </FormControl>
          </Grid>
        </Grid>
      </PaperPart>
    );
  };

  /**
   * 社外ユーザの要素生成
   * @return {*}
   */
  _getoutUserInfo() {
    let outCorp=[];
    for (const corp of this.corpList) {
      if (corp.cd!=CORP_CD.CBID_USER) {
        outCorp.push(corp);
      }
    }
    let outCorpSelectList = getKbnList(outCorp);
    let prefSelectList = getKbnList(this.prefList);
    let isReadOnly = !this.isVisible;
    return (
      <PaperPart>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="userId" item xs={12} sm={3}>
            <Field
              id="userId"
              name="userId"
              component={renderTextField}
              className="fields"
              label="ユーザID"
              fullWidth
              type="text"
              required={true}
              InputProps={{
                readOnly: true,
              }}
            />
          </Grid>
          <Grid key="userNm" item xs={12} sm={3}>
            <Field
              id="userNm"
              name="userNm"
              component={renderTextField}
              className="fields"
              onChange={this.textChange}
              label="ユーザ氏名"
              fullWidth
              type="text"
              required={true}
              InputProps={{
                readOnly: isReadOnly,
              }}
            />
          </Grid>
          <Grid key="userNmkn" item xs={12} sm={3}>
            <Field
              id="userNmkn"
              name="userNmkn"
              component={renderTextField}
              className="fields"
              label="ユーザ氏名カナ"
              onChange={this.textChange}
              fullWidth
              type="text"
              required={false}
              InputProps={{
                readOnly: isReadOnly,
              }}
            />
          </Grid>
          <Grid key="abbrUserNm" item xs={12} sm={3}>
            <Field
              id="abbrUserNm"
              name="abbrUserNm"
              component={renderTextField}
              className="fields"
              label="ユーザ略名"
              onChange={this.textChange}
              fullWidth
              type="text"
              required={false}
              InputProps={{
                readOnly: isReadOnly,
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="corpCd" item xs={12} sm={3}>
            <Field
              id="corpCd"
              name="corpCd"
              component={renderSelect}
              className="fields"
              label="会社"
              fullWidth
              required={true}
              validate={[
              ]}
              onChange={this.corpChange}
              InputProps={{
                readOnly: isReadOnly,
                shrink: true,
              }}
            >
              {outCorpSelectList}
            </Field>
          </Grid>
          <Grid key="toDoFuKen" item xs={12} sm={2}>
            <Field
              id="toDoFuKen"
              name="toDoFuKen"
              component={renderSelect}
              className="fields"
              label="都道府県"
              onChange={this.prefChange}
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: isReadOnly,
                shrink: true,
              }}
            >
              {prefSelectList}
            </Field>
          </Grid>
          <Grid key="surveyAgencyOfficeCode" item xs={12} sm={3}>
            <Field
              id="surveyAgencyOfficeCode"
              name="surveyAgencyOfficeCode"
              component={renderSelect}
              className="fields"
              label="調査機関事業所"
              fullWidth
              required={true}
              onChange={this.textChange}
              validate={[
              ]}
              InputProps={{
                readOnly: isReadOnly,
                shrink: true,
              }}
            >
              {this.state.surveyAgencyOfficeCodes}
            </Field>
          </Grid>
          <Grid key="yukoStartYmd" item xs={12} sm={2}>
            <Field
              id="yukoStartYmd"
              name="yukoStartYmd"
              component={renderTextField}
              className="fields"
              fullWidth
              required={true}
              label="有効開始年月日"
              type="date"
              onChange={this.textChange}
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: isReadOnly,
              }}
            />
          </Grid>
          <Grid key="yukoEndYmd" item xs={12} sm={2}>
            <Field
              id="yukoEndYmd"
              name="yukoEndYmd"
              component={renderTextField}
              className="fields"
              fullWidth
              required={true}
              onChange={this.textChange}
              label="有効終了年月日"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                readOnly: isReadOnly,
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="userTypeCode" item xs={12} sm={3}>
            <Field
              id="userTypeCode"
              name="userTypeCode"
              component={renderSelect}
              className="fields"
              label="ユーザ種別"
              fullWidth
              onChange={this.textChange}
              required={true}
              validate={[
              ]}
              InputProps={{
                readOnly: isReadOnly,
                shrink: true,
              }}
            >
              {this.state.userTypeSelectList}
            </Field>
          </Grid>
          <Grid key="mailaddress" item xs={12} sm={3}>
            <Field
              id="mailaddress"
              name="mailaddress"
              component={renderTextField}
              className="fields"
              fullWidth
              required={true}
              label="メールアドレス"
              type="text"
              onChange={this.textChange}
              InputProps={{
                readOnly: isReadOnly,
              }}
            />
          </Grid>
          <Grid key="noticeTarget" item xs={12} sm={3}>
            <FormControl component="fieldset" className="formControl">
              <FormGroup row={true}>
                <Field className="checkbox"
                  id="noticeTarget"
                  name="noticeTarget"
                  component={renderCheckbox}
                  label="通知対象"
                  onChange={this.textChange}
                  validate={[]}
                  sx={{marginLeft: '20px'}}
                  disabled={isReadOnly}
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid key="isValid" item xs={12} sm={3}>
            <FormControl component="fieldset" className="formControl">
              <FormGroup row={true}>
                <Field className="checkbox"
                  id="isValid"
                  name="isValid"
                  component={renderCheckbox}
                  label="有効フラグ"
                  onChange={this.textChange}
                  disabled={isReadOnly}
                  validate={[]}
                  sx={{marginLeft: '20px'}}
                />
              </FormGroup>
            </FormControl>
          </Grid>
        </Grid>
      </PaperPart>
    );
  };

  /**
   * チェックボックス変更
   * @param {*} e
   * @param {*} v="isindefinite" type="c
   */
  prefChange = (e, v) => {
    let surveyAgencyOfficeSelectList={};
    if (v==='') {
      surveyAgencyOfficeSelectList=getKbnList(this.surveyAgencyOfficeList);
    } else {
      let surveyAgencyOfficeKen=[];
      for (const surveyAgency of this.surveyAgencyOfficeList) {
        if (surveyAgency.valueString4==v) {
          surveyAgencyOfficeKen.push(surveyAgency);
        }
      }
      surveyAgencyOfficeSelectList=getKbnList(surveyAgencyOfficeKen);
    }
    this.setState({surveyAgencyOfficeCodes: surveyAgencyOfficeSelectList});
    this.setState({isChanged: true, isButtonDisabled: false});
  };

  /**
   * チェックボックス変更
   * @param {*} e
   * @param {*} v="isindefinite" type="c
   */
  corpChange = (e, v) => {
    let userTypeSelectList={};
    if (v==='') {
      userTypeSelectList=getKbnList(this.userTypeList);
    } else {
      let userTypeCorp=[];
      for (const userType of this.userTypeList) {
        if (userType.valueString1==v) {
          userTypeCorp.push(userType);
        }
      }
      userTypeSelectList=getKbnList(userTypeCorp);
    }
    this.setState({userTypeSelectList: userTypeSelectList});
    this.setState({isChanged: true, isButtonDisabled: false});
  };

  /**
     * 桁数チェック
     * @param {*} maxLength
     * @param {*} header
     * @param {*} value
     * @param {*} rowIndex
     * @return {*} 結果
     */
  _lengthCheck = (maxLength, header, value, rowIndex=' ') => {
    if (maxLength && maxLength > 0) {
      return lengthCheck(header, value, maxLength, rowIndex);
    }
    return {};
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    const {
      handleSubmit,
    } = this.props;
    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        {this.isVisible && <Grid key="key1001CreateSen1" item>
          <PositiveButton
            id="btn1001CreateSen1"
            onClick={this.doSave}
            variant="contained"
            startIcon={<SaveIcon />}
            disabled={this.state.isButtonDisabled}
          >
            <span>更新</span>
          </PositiveButton>
        </Grid>}
        {(this.state.userMode === 0 && this.isVisible) &&
        <Grid key="key1001CreateSen1" item>
          <PositiveButton
            id="btn1001CreateSen1"
            onClick={handleSubmit(this.doPasswordReset)}
            variant="contained"
            startIcon={<SaveIcon />}
          >
            <span>パスワードリセット</span>
          </PositiveButton>
        </Grid>
        }
        {this.state.modalOpen &&
        <ResetPassword
          modalOpen={this.state.modalOpen}
          handleClose={this.handleCloseModal}
        >
        </ResetPassword>
        }
      </Grid>
    );
  };

  /**
   * 画面遷移
   * @param {object} path 遷移パス
   */
  doMoveNext = async (path) => {
    if (this.state.isChanged) {
      this.props.doShowMessage({
        message: 'TKSCS00038W',
        action: () => {
          // OKを押すと画面遷移
          this.props.navigate(path);
        },
      });
    } else {
      // 編集されていない場合は確認なしで遷移
      this.props.navigate(path);
    }
  };

  /**
   * 画面描画
   * @return {*}
   */
  render() {
    const {userInfo, genericMap} = this.props;
    const {classes,
    } = this.props;
    this.corpList= searchMap(genericMap, CATEGORY_TYPE.CORP_CD);
    this.prefList=searchMap(genericMap, CATEGORY_TYPE.PREF_CODE);
    this.userTypeList=searchMap(genericMap, CATEGORY_TYPE.USER_TYPE_CODE);
    this.surveyAgencyOfficeList=searchMap(
        genericMap, CATEGORY_TYPE.SURVEY_AGENCY_OFFICE_CODE);
    this.dig4ZgsyoList= searchMap(genericMap, CATEGORY_TYPE.NW_OFFICE_CODE);
    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          ActorName={userInfo.ActorName}
          footerBtn={footerBtn}
        >
          <CustomBreadcrumbs key="keyBreadcrumbs" items={this.state.transitionList} move={this.doMoveNext}/>
          <Grid key="keySCA1001Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages} />
          </Grid>

          <Grid key="keyBFZ1004" item xs={12}>
            {this.state.userVisableFlg && this._getuserInfo()}
            {this.state.outUserVisableFlg && this._getoutUserInfo()}
          </Grid>
        </MainContainer>
      </form>
    );
  }
}

const FORM_NAME = 'SCZ1004FORM';
Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
    syncWarnings: getFormSyncWarnings(FORM_NAME)(state),
  };
})(Container));

Container.propTypes = {
  classes: PropTypes.object,
  userInfo: PropTypes.object,
  values: PropTypes.object,
  doShowMessage: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
  genericMap: PropTypes.object,
  doSetReferenceMode: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
  sendAuthenticationCode: PropTypes.func,
  menuItems: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    userInfo: state.auth.userInfo,
    initialValues: state.common.setInitValues,
    genericMap: state.common.generalPurposeMap,
    menuItems: state.auth.menuItems,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doSetInitValues: commonOperations.doSetInitValues,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
  sendAuthenticationCode: authOperations.sendAuthenticationCodeOperation,
};

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);
